import React, { FunctionComponent } from "react";
import styles from "../styles/CompaniesDashboard.css";
import Body from "./Body";

interface Props {}

const CompaniesDashboard: FunctionComponent<Props> = () => {
    
    return (
        <div className={styles.bodyContainer} >
            <Body />
        </div>
    )
}

export default CompaniesDashboard;